// -- Import Actions
import { commonActions } from  '../../actions/commonActions';
import { connect } from 'react-redux';
import PendingByForm from '../../components/order/PendingForm';
import {API_FETCH} from '../../services/FetchService';
import {alertConstants, commonConstants} from "../../constants";
import {orderAddItem, orderSetItem, orderGetItem,orderItemId} from "../../actions/orderActions";


const mapStateToProps = state => {
    return {
        common: state.common,
        initialValues: state.order.getItem,
        userValue : state.app.currentUser,
    }
};


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getItem: (id) => {
        dispatch(getItem(id));
    },
    setOrderId: (orderId) => {
        return(dispatch(orderItemId(orderId)))
    },

    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(add(value));
    }

});


/* ------------------------------------------------ */
/* -------- Functions of mapDispatchToProps ------- */
/* ------------------------------------------------ */

const add = (values,mode) => {

    return (dispatch, getState) => {
        let states = getState();

        let orderId;
        if(states.order.orderItemId)
            orderId = states.order.orderItemId
        else{
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'درخواست نامعتبر میباشد'
            })
        }

        let formData = {
            'pending_description' : values.pending_description
        };

        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.put('order/pending/'+orderId, formData).then(res => {
            dispatch(orderAddItem(res.data));
            if(res.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ایجاد'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

const getItem = (id) => {
    return (dispatch, getState) => {
        API_FETCH.get('order/'+id).then(orderInfo => {
            dispatch(orderGetItem(orderInfo.data.result));
        }).catch(error => {
            console.log(error);
        });
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(PendingByForm);
